import { AccountService } from 'src/app/services/user/account.service';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { I18ConfigService } from './I18-config.service';
import { HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from '../localStorage/localStorage.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';
import { Capacitor } from '@capacitor/core';

interface TXDefaultParams {
  key: string;
  pid: string;
  platform: string;
  airport: string;
  lang: string;
  currency: string;
  userid?: string | number;
  client: string;
}

@Injectable({
  providedIn: 'root',
})
export class TxService {
  // private httpOptions: HttpHeaders = new HttpHeaders();
  private defaultParams: any;
  private baseUrl = environment.txBaseUrl;

  private getServices = '/api/getServices';
  private getAppPage = '/api/getAppPage';
  private getEnquiryForm = '/api/autocheckoutform';
  private submitServiceRequest = '/api/submitMultiPassengerServiceRequest';
  private verifyBooking = '/api/verifyBooking';
  private checkSoftLogin = '/api/checkSoftLogin';
  private checkGuestLogin = '/api/checkGuestLogin';
  private changeUserType = '/api/changeUserType';
  private sendOtp = '/api/sendOtp';
  private sendEmailOtp = '/api/sendEmailOtp';
  private validateSerialNumber = '/api/validateSerialNumber';
  private verifyOtp = '/api/verifyOtp';
  private userRegistration = '/api/userRegistration';
  private myServiceRequests = '/api/myServiceRequests';
  private getPoints = '/api/getPoints';
  private cancelServiceRequest = '/api/cancelRequest';
  private getServiceDetail = '/api/getServiceDetail';
  private getRetailersDetailsV2 = '/api/getRetailersDetailsV2';
  private getProductListResponse = '/api/getProductListResponse';
  private getAirportList = '/api/getAirportList';
  private getAirlineList = '/api/flightbooking/airlineSearch';
  private gethomepage = '/api/gethomepage';
  private getDynamicForm = '/api/getDynamicForm';
  private getRegistrationForm = '/api/getRegistrationForm';

  private getFlights = '/api/getFlights';
  private flightDetail = '/api/flightStatus';
  private myFlights = '/api/trackFlight';
  private getCalenderFlights = '/api/getCalenderFlights';
  private saveTrackFlightV2 = '/api/saveTrackFlightV2';
  private stopFlightTrack = '/api/stopFlightTrack';
  private flightSearchById = '/api/flightStatusOld';
  private flightSearchByRoute = '/api/flightSearchByRoute';
  private updateCartState = '/api/updateCartState';
  private getCartList = '/api/getCartList';
  private getFinalPrice = '/api/checkPrice';
  private checkoutRetailCart = '/api/checkoutcart';
  private checkoutCart = '/api/checkoutFood';
  private getProductDetails = '/api/getProductDetails';
  private autoCheckoutForm = '/api/autocheckoutform';
  private verifyMembershipVoucher = '/api/verifyMembershipVoucher';
  private subscribeMembership = '/api/subscribeMembership';
  private getAirportMaps = '/api/getAirportMaps';
  private mobileRegistration = '/api/mobileRegistration';
  private parseBarcodeInfo = '/api/parseBarcodeInfo';
  private getCountries = '/api/getCountries';
  private getCitiesByCountry = '/api/getCitiesByCountry';
  private searchCity = '/api/searchCity';
  private deactivateUser = '/api/deleteUser';
  private addUserAction = '/api/addUserAction';
  private logout = '/api/logout';

  private hotelCancelBooking = '/api/hotelbooking/cancelBooking';
  private hotelDetails = '/api/hotelbooking/getHotelResults';
  private hotelSearch = '/api/hotelbooking/search';
  private hotelReview = '/api/hotelbooking/getRoomDetails';
  private createBooking = '/api/hotelbooking/createBooking';
  private hotelBookingDetail = '/api/hotelbooking/getBookingDetail';
  private bookHotel = '/api/hotelbooking/bookHotel';
  private hotelDealsCustomReqAlertApi =
    '/api/hotelbooking/hotelDealCustomReqAlert';
  private getOrder = '/api/dutyfree/getOrderDetail';
  private cancelOrder = '/api/cancelOrder';
  private offerListApi = '/api/getOfferList';

  private flightBookingSearchRequest = '/api/flightbooking/flightSearch';
  private getFlightBookingReview = '/api/flightbooking/getBookingReview';
  private bookFlightRequest = '/api/flightbooking/bookFlight';
  private getFlightBookingDetail = '/api/flightbooking/getBookingDetail';
  private fareRule = '/api/flightbooking/fareRule';
  private releaseBooking = '/api/flightbooking/releaseBooking';
  private cancelFlightBooking = '/api/flightbooking/cancelBooking';
  private checkBookingStatus = '/api/flightbooking/fetchBookingStatus';
  private checkHotelBookingStatus = '/api/hotelbooking/fetchBookingStatus';
  private flightBookingHistory = '/api/flightbooking/getFlightBookingHistory';
  private createFlightBooking = '/api/flightbooking/createBooking';
  private hotelBookingHistory = '/api/hotelbooking/getHotelBookingHistory';
  private generatePaymentTokens = '/api/flightbooking/generatePaymentTokens';

  private flightV2Search = '/api/v2/flight/search';
  private flightV2Details = '/api/v2/flight/details';
  private flightV2FareRules = '/api/v2/flight/fareRules';
  private flightV2Pricing = '/api/v2/flight/pricing';
  private flightV2Ssr = '/api/v2/flight/ssr';
  private flightV2SeatMap = '/api/v2/flight/seatMap';
  private flightV2CreateBooking = '/api/v2/flight/createBooking';
  private flightV2ProductBooking = '/api/v2/flight/booking';
  private flightV2FetchBookingStatus = '/api/v2/flight/fetchBookingStatus';
  private flightV2GetBookingDetails = '/api/v2/flight/getBookingDetails';
  private flightV2Cancel = '/api/v2/flight/cancel';
  private flightV2BookingHistory = '/api/v2/flight/bookingHistory';
  private tierV2Offers = '/api/tiers/v2/offers';

  private createPaymentSession = '/api/hotelbooking/checkout';
  private syncCalenderEventsApi = '/api/syncCalenderLLM';
  private requestVoucherApi = '/api/createVoucherRequest';
  private getNotifications = '/api/getNotification';
  private updateNotificationStatus = '/api/updateNotificationViewStatus';
  private updateType = '/api/getAppUpdateStatus';
  private sendLocationCoordinates = '/api/sendLocationCoordinates';
  private getAirportInfo = '/api/getAirportInfo';
  private getCityList = '/api/getCityList';

  private getUserGuestList = '/api/getUserGuestList';
  private getUserGuestListV2 = '/api/getUserGuestListV2';
  private addUserGuest = '/api/addUserGuest';
  private editUserGuest = '/api/editUserGuest';
  private deleteUserGuest = '/api/deleteUserGuest';

  // Autocheckout
  private fetchOrderStatus = '/api/dutyfree/fetchOrderStatus';
  private fetchCartStatus = '/api/dutyfree/fetchCartStatus';
  private cancelCheckoutOrder = '/api/dutyfree/cancelCartCheckout';
  private checkoutV2RetailCart = '/api/dutyfree/checkoutcart';
  private getDutyfreeV2CartList = '/api/dutyfree/getCartList';
  private dutyfreeV2UpdateCartState = '/api/dutyfree/updateCartState';
  private verifyBookingV2 = '/api/dutyfree/verifyBooking';

  private verifyLogin = '/api/verifyLogin';
  private uploadFlightTicket = '/api/uploadItinerary';
  private seatMap = '/api/flightbooking/seatMap';
  private getCarousels = '/api/getCarousels';
  private getPublicCarousels = '/api/getPublicCarousels';

  // Bus Booking API
  private busBookingSearch = '/api/busbooking/search';
  private busBookingAvailability = '/api/busbooking/availability';
  private busSeatArrangement = '/api/busbooking/seatArrangement';
  private busBookingBookSeat = '/api/busbooking/bookSeat';
  private busBookingBlockSeat = '/api/busbooking/blockSeat';
  private busBookingDetails = '/api/busbooking/bookingDetails';
  private busBookingFetchBookingStatus = '/api/busbooking/fetchBookingStatus';
  private getBusBookingHistory = '/api/busbooking/getBusBookingHistory';
  private confirmBusCancellation = '/api/busbooking/confirmBusCancellation';
  private getBusCancellationDetails =
    '/api/busbooking/getBusCancellationDetails';
  private getBusRouteSequence = '/api/busbooking/getBusRouteSequence';
  private getBusCancellationPolicies =
    '/api/busbooking/getBusCancellationPolicies';
  private getBusBookingReview = '/api/busbooking/getBookingReview';

  // Airport Services Booking API
  private airportServicesSearch = '/api/airportServices/search';
  private airportServicesCarousels = '/api/airportServices/carousels';
  private airportServicesCarouselTabs = '/api/airportServices/carouselTabs';
  private airportServicesCarouselItems = '/api/airportServices/carouselItems';
  private airportServicesCreateBooking = '/api/airportServices/createBooking';
  private airportServicesFetchBooking = '/api/airportServices/fetchBooking';
  private airportServicesBooking = '/api/airportServices/booking';
  private airportServicesEsimServices = '/api/airportServices/esim-services';
  private airportServicesGetAirportList =
    '/api/airportServices/getAirportList';
  private airportServicesToursAndAttractionsSearch =
    '/api/airportServices/tours-and-attractions/search';
  private airportServicesFetchBookingStatus =
    '/api/airportServices/fetchBookingStatus';
  private airportServicesGetBookingDetails =
    '/api/airportServices/getBookingDetails';
  private airportServicesGetBookingHistory =
    '/api/airportServices/getAirportServiceBookingHistory';
  private airportServicesBookingPolicies =
    '/api/airportServices/descriptions/booking-policies';
  private airportServicesProductAvailability =
    '/api/airportServices/products/availability';

  constructor(
    private i18ConfigService: I18ConfigService,
    private localStorageData: LocalStorageService
  ) {}

  get getAppKey() {
    return JSON.parse(this.localStorageData.getItem(localStorageKeys.PARTNER))
      ?.key;
  }
  get getAppPid() {
    return JSON.parse(this.localStorageData.getItem(localStorageKeys.PARTNER))
      ?.pid;
  }

  getDefaultApiParams() {
    const platform =
      Capacitor && Capacitor.getPlatform && Capacitor.getPlatform() !== 'web'
        ? Capacitor.getPlatform()
        : 'web';

    this.defaultParams = {
      key: this.getAppKey || 'palsgcvgscvvs',
      pid: this.getAppPid || 'smt',
      platform,
      client: platform === 'web' ? 'web' : 'txvip',
      lang: this.i18ConfigService.getLanguage(),
      currency: this.i18ConfigService.getCurrency(),
    } as TXDefaultParams;
    // const userId = localStorage.getItem('userId');
    // if (typeof userId !== 'undefined' && userId !== null) {
    //   this.defaultParams.userid = userId;
    // }
    return this.defaultParams;
  }

  getMultipartFormHeaders(token) {
    return new HttpHeaders({
      Authorization: 'Bearer ' + token,
    });
  }

  getHeaders(token) {
    return new HttpHeaders({
      'content-type': 'application/json',
      // eslint-disable-next-line @typescript-eslint/naming-convention
      Authorization: 'Bearer ' + token,
    });
  }

  getServicesApi() {
    return this.baseUrl + this.getServices;
  }
  getAppPageApi() {
    return this.baseUrl + this.getAppPage;
  }
  getEnquiryFormApi() {
    return this.baseUrl + this.getEnquiryForm;
  }
  submitServiceRequestApi() {
    return this.baseUrl + this.submitServiceRequest;
  }
  sendOtpApi() {
    return this.baseUrl + this.sendOtp;
  }
  sendEmailOtpApi() {
    return this.baseUrl + this.sendEmailOtp;
  }
  checkSoftLoginApi() {
    return this.baseUrl + this.checkSoftLogin;
  }
  checkGuestLoginApi() {
    return this.baseUrl + this.checkGuestLogin;
  }
  validateSerialNumberApi() {
    return this.baseUrl + this.validateSerialNumber;
  }
  logoutApi() {
    return this.baseUrl + this.logout;
  }
  verifyOtpApi() {
    return this.baseUrl + this.verifyOtp;
  }
  userRegistrationApi() {
    return this.baseUrl + this.userRegistration;
  }
  myServiceRequestsApi() {
    return this.baseUrl + this.myServiceRequests;
  }
  cancelServiceRequestApi() {
    return this.baseUrl + this.cancelServiceRequest;
  }
  getServiceDetailApi() {
    return this.baseUrl + this.getServiceDetail;
  }
  getPointsApi() {
    return this.baseUrl + this.getPoints;
  }
  getRetailersDetailsV2Api() {
    return this.baseUrl + this.getRetailersDetailsV2;
  }
  getProductListResponseApi() {
    return this.baseUrl + this.getProductListResponse;
  }
  getAirportMapsApi() {
    return this.baseUrl + this.getAirportMaps;
  }
  getAirportListApi() {
    return this.baseUrl + this.getAirportList;
  }
  getAirlineListApi() {
    return this.baseUrl + this.getAirlineList;
  }
  gethomepageApi() {
    return this.baseUrl + this.gethomepage;
  }
  getDynamicFormApi() {
    return this.baseUrl + this.getDynamicForm;
  }
  getFlightsApi() {
    return this.baseUrl + this.getFlights;
  }
  getFlightDetailApi() {
    return this.baseUrl + this.flightDetail;
  }
  getMyFlightsApi() {
    return this.baseUrl + this.myFlights;
  }
  getCalenderFlightsApi() {
    return this.baseUrl + this.getCalenderFlights;
  }
  saveTrackFlightApi() {
    return this.baseUrl + this.saveTrackFlightV2;
  }
  stopTrackFlightApi() {
    return this.baseUrl + this.stopFlightTrack;
  }
  flightSearchByIdApi() {
    return this.baseUrl + this.flightSearchById;
  }
  flightSearchByRouteApi() {
    return this.baseUrl + this.flightSearchByRoute;
  }
  updateCartStateApi() {
    return this.baseUrl + this.updateCartState;
  }
  dutyfreeV2updateCartStateApi() {
    return this.baseUrl + this.dutyfreeV2UpdateCartState;
  }
  getCartListApi() {
    return this.baseUrl + this.getCartList;
  }
  getDutyfreeCartListApi() {
    return this.baseUrl + this.getDutyfreeV2CartList;
  }
  getFinalPriceApi() {
    return this.baseUrl + this.getFinalPrice;
  }
  checkoutRetailCartApi() {
    return this.baseUrl + this.checkoutRetailCart;
  }
  checkoutRetailv2CartApi() {
    return this.baseUrl + this.checkoutV2RetailCart;
  }
  checkoutCartApi() {
    return this.baseUrl + this.checkoutCart;
  }
  getProductDetailsApi() {
    return this.baseUrl + this.getProductDetails;
  }
  autoCheckoutFormApi() {
    return this.baseUrl + this.autoCheckoutForm;
  }
  verifyMembershipVoucherApi() {
    return this.baseUrl + this.verifyMembershipVoucher;
  }
  getSubscribeMembershipApi() {
    return this.baseUrl + this.subscribeMembership;
  }
  mobileRegistrationApi() {
    return this.baseUrl + this.mobileRegistration;
  }
  parseBarcodeInfoApi() {
    return this.baseUrl + this.parseBarcodeInfo;
  }
  getCountriesApi() {
    return this.baseUrl + this.getCountries;
  }
  getCitiesByCountryApi() {
    return this.baseUrl + this.getCitiesByCountry;
  }
  searchCityApi() {
    return this.baseUrl + this.searchCity;
  }
  getHotelDetailsApi() {
    return this.baseUrl + this.hotelDetails;
  }
  gethotelSearchApi() {
    return this.baseUrl + this.hotelSearch;
  }
  getHotelReviewApi() {
    return this.baseUrl + this.hotelReview;
  }
  getCreateBookingApi() {
    return this.baseUrl + this.createBooking;
  }
  getHotelBookingApi() {
    return this.baseUrl + this.hotelBookingDetail;
  }
  deactivateUserApi() {
    return this.baseUrl + this.deactivateUser;
  }
  addUserActionApi() {
    return this.baseUrl + this.addUserAction;
  }
  getHotelCancelBooking() {
    return this.baseUrl + this.hotelCancelBooking;
  }
  flightBookingSearchRequestApi() {
    return this.baseUrl + this.flightBookingSearchRequest;
  }
  getFlightBookingReviewApi() {
    return this.baseUrl + this.getFlightBookingReview;
  }
  getFlightBookingHistoryApi() {
    return this.baseUrl + this.flightBookingHistory;
  }
  bookFlightRequestApi() {
    return this.baseUrl + this.bookFlightRequest;
  }

  createFlightBookingRequestApi() {
    return this.baseUrl + this.createFlightBooking;
  }
  getFlightBookingDetailApi() {
    return this.baseUrl + this.getFlightBookingDetail;
  }
  generatePaymentTokensApi() {
    return this.baseUrl + this.generatePaymentTokens;
  }
  releaseBookingApi() {
    return this.baseUrl + this.releaseBooking;
  }
  cancelFlightBookingApi() {
    return this.baseUrl + this.cancelFlightBooking;
  }
  checkBookingStatusApi() {
    return this.baseUrl + this.checkBookingStatus;
  }
  checkHotelBookingStatusApi() {
    return this.baseUrl + this.checkHotelBookingStatus;
  }
  getHotelBookingHistoryApi() {
    return this.baseUrl + this.hotelBookingHistory;
  }
  flightFareRulesApi() {
    return this.baseUrl + this.fareRule;
  }

  flightV2SearchApi() {
    return this.baseUrl + this.flightV2Search;
  }
  flightV2DetailsApi() {
    return this.baseUrl + this.flightV2Details;
  }
  flightV2FareRulesApi() {
    return this.baseUrl + this.flightV2FareRules;
  }
  flightV2PricingApi() {
    return this.baseUrl + this.flightV2Pricing;
  }
  flightV2SsrApi() {
    return this.baseUrl + this.flightV2Ssr;
  }
  flightV2SeatMapApi() {
    return this.baseUrl + this.flightV2SeatMap;
  }
  flightV2CreateBookingApi() {
    return this.baseUrl + this.flightV2CreateBooking;
  }
  flightV2ProductBookingApi() {
    return this.baseUrl + this.flightV2ProductBooking;
  }
  flightV2FetchBookingStatusApi() {
    return this.baseUrl + this.flightV2FetchBookingStatus;
  }
  flightV2GetBookingDetailsApi() {
    return this.baseUrl + this.flightV2GetBookingDetails;
  }
  flightV2BookingHistoryApi() {
    return this.baseUrl + this.flightV2BookingHistory;
  }
  flightV2CancelApi() {
    return this.baseUrl + this.flightV2Cancel;
  }
  tierV2OffersApi() {
    return this.baseUrl + this.tierV2Offers;
  }
  getOrderApi() {
    return this.baseUrl + this.getOrder;
  }
  getCancelOrderApi() {
    return this.baseUrl + this.cancelOrder;
  }
  getCreatePaymentSessionApi() {
    return this.baseUrl + this.createPaymentSession;
  }
  getbookHotelApi() {
    return this.baseUrl + this.bookHotel;
  }
  getHotelDealsCustomReqAlertApi() {
    return this.baseUrl + this.hotelDealsCustomReqAlertApi;
  }
  getRegistrationFormApi() {
    return this.baseUrl + this.getRegistrationForm;
  }
  getSyncCalenderEventsApi() {
    return this.baseUrl + this.syncCalenderEventsApi;
  }
  getNotifcationApi() {
    return this.baseUrl + this.getNotifications;
  }
  getUpdateNotificationStatusApi() {
    return this.baseUrl + this.updateNotificationStatus;
  }
  getOfferListApi() {
    return this.baseUrl + this.offerListApi;
  }
  createVoucherRequestApi() {
    return this.baseUrl + this.requestVoucherApi;
  }
  verifyBookingApi() {
    return this.baseUrl + this.verifyBooking;
  }
  sendLocationCoordinatesApi() {
    return this.baseUrl + this.sendLocationCoordinates;
  }
  getUpdateTypeApi() {
    return this.baseUrl + this.updateType;
  }
  getAirportInfoApi() {
    return this.baseUrl + this.getAirportInfo;
  }
  getCityListApi() {
    return this.baseUrl + this.getCityList;
  }

  //Autocheckout
  fetchOrderStatusApi() {
    return this.baseUrl + this.fetchOrderStatus;
  }
  fetchCartStateApi() {
    return this.baseUrl + this.fetchCartStatus;
  }
  cancelAutoCheckoutOrder() {
    return this.baseUrl + this.cancelCheckoutOrder;
  }
  verifyBookingV2Api() {
    return this.baseUrl + this.verifyBookingV2;
  }
  verifyLoginApi() {
    return this.baseUrl + this.verifyLogin;
  }
  uploadFlightTicketApi() {
    return this.baseUrl + this.uploadFlightTicket;
  }
  getSeatMapApi() {
    return this.baseUrl + this.seatMap;
  }
  getUserGuestListApi() {
    return this.baseUrl + this.getUserGuestList;
  }
  getUserGuestListV2Api() {
    return this.baseUrl + this.getUserGuestListV2;
  }

  changeUserTypeApi() {
    return this.baseUrl + this.changeUserType;
  }
  addUserGuestApi() {
    return this.baseUrl + this.addUserGuest;
  }
  editUserGuestApi() {
    return this.baseUrl + this.editUserGuest;
  }
  deleteUserGuestApi() {
    return this.baseUrl + this.deleteUserGuest;
  }
  getCarouselsApi() {
    return this.baseUrl + this.getCarousels;
  }

  getPublicCarouselsApi() {
    return this.baseUrl + this.getPublicCarousels;
  }

  // Bus Booking API methods
  getBusBookingSearchApi() {
    return this.baseUrl + this.busBookingSearch;
  }
  getBusBookingAvailabilityApi() {
    return this.baseUrl + this.busBookingAvailability;
  }
  getBusSeatArrangementApi() {
    return this.baseUrl + this.busSeatArrangement;
  }
  getBusBookingBookSeatApi() {
    return this.baseUrl + this.busBookingBookSeat;
  }
  getBusBookingBlockSeatApi() {
    return this.baseUrl + this.busBookingBlockSeat;
  }
  getBusBookingDetailsApi() {
    return this.baseUrl + this.busBookingDetails;
  }
  getBusBookingFetchBookingStatusApi() {
    return this.baseUrl + this.busBookingFetchBookingStatus;
  }
  getBusBookingHistoryApi() {
    return this.baseUrl + this.getBusBookingHistory;
  }
  getConfirmBusCancellationApi() {
    return this.baseUrl + this.confirmBusCancellation;
  }
  getBusCancellationDetailsApi() {
    return this.baseUrl + this.getBusCancellationDetails;
  }
  getBusRouteSequenceApi() {
    return this.baseUrl + this.getBusRouteSequence;
  }
  getBusCancellationPoliciesApi() {
    return this.baseUrl + this.getBusCancellationPolicies;
  }
  getBusBookingReviewApi() {
    return this.baseUrl + this.getBusBookingReview;
  }

  // Airport Services Booking API methods
  getAirportServicesSearchApi() {
    return this.baseUrl + this.airportServicesSearch;
  }
  getAirportServicesCarouselsApi() {
    return this.baseUrl + this.airportServicesCarousels;
  }
  getAirportServicesCarouselTabsApi() {
    return this.baseUrl + this.airportServicesCarouselTabs;
  }
  getAirportServicesCarouselItemsApi() {
    return this.baseUrl + this.airportServicesCarouselItems;
  }
  getAirportServicesCreateBookingApi() {
    return this.baseUrl + this.airportServicesCreateBooking;
  }
  getAirportServicesFetchBookingApi() {
    return this.baseUrl + this.airportServicesFetchBooking;
  }
  getAirportServicesBookingApi() {
    return this.baseUrl + this.airportServicesBooking;
  }
  getAirportServicesEsimServicesApi() {
    return this.baseUrl + this.airportServicesEsimServices;
  }
  getAirportServicesGetAirportListApi() {
    return this.baseUrl + this.airportServicesGetAirportList;
  }
  getAirportServicesToursAndAttractionsSearchApi() {
    return this.baseUrl + this.airportServicesToursAndAttractionsSearch;
  }
  getAirportServicesFetchBookingStatusApi() {
    return this.baseUrl + this.airportServicesFetchBookingStatus;
  }
  getAirportServicesGetBookingDetailsApi() {
    return this.baseUrl + this.airportServicesGetBookingDetails;
  }
  getAirportServicesGetBookingHistoryApi() {
    return this.baseUrl + this.airportServicesGetBookingHistory;
  }
  getAirportServicesBookingPoliciesApi() {
    return this.baseUrl + this.airportServicesBookingPolicies;
  }
  getAirportServicesProductAvailabilityApi() {
    return this.baseUrl + this.airportServicesProductAvailability;
  }
}
